<template>
	<div class="site-section products-section">
	<loading :active.sync="is_loading"></loading>
		<div v-if="$route.name !== 'home'" class="product-container my-3 container">
			
			<div class="row" v-if="products.length > 0">
				<div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="product in products">
					<div class="card product-card my-3 mb-3">
						<router-link :to="{ name: 'producto', params: {id: product.id} }"><img :src="product.big_picture" :alt="product.name" class="card-img-top"></router-link>
						<div class="card-body bg-red-moi">
							<h5 class="card-title" style="font-size: 0.96rem">
								<router-link class="text-white" :to="{ name: 'producto', params: {id: product.id} }">
									{{ product.name }}
								</router-link>
							</h5>
							<p class="card-text text-white" v-if="product.prices.length > 1">${{ product.prices.length > 0 ? product.prices[0].price + " - " + "$"+product.prices[product.prices.length-1].price : '' }}</p>
							<p class="card-text text-white h3" v-else>${{ product.prices.length > 0 ? product.prices[0].price : '' }}</p>
							
						</div>
						<div class="card-footer border-0 bg-red-moi">
							<router-link :to="{ name: 'producto', params: {id: product.id} }" class="btn btn-rounded" style="font-weight: bold; background: #FFF; text-orientation: center; color: #F04150; border-radius: 12px; border-color: white;">VER PRODUCTO</router-link>
						</div>
					</div>
				</div>
			</div><!-- .row -->
			<div class="row" v-else>
				<div class="col">
					<h3>{{ this.no_product }}</h3>
				</div>
			</div>
		</div>
		<div v-else class="product-container my-3 container">
			<h2 class="text-left">Merch</h2>
			<div class="row" v-if="products.length > 0">
				<div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="product in products.filter(property => property.product_type_id.id === 9)" v-bind:key="product.id">
					<div class="card product-card my-3 mb-3">

						<router-link :to="{ name: 'producto', params: {id: product.id} }" class="text-white">
							<img :src="product.big_picture" :alt="product.name" class="card-img-top">
						</router-link>
					
						<div class="card-body bg-red-moi">
							<h5 class="card-title" style="font-size: 0.96rem">
								<router-link :to="{ name: 'producto', params: {id: product.id} }" class="text-white">
									{{ product.name }}
								</router-link>
							</h5>
							<p class="card-text text-white" v-if="product.prices.length > 1">${{ product.prices.length > 0 ? product.prices[0].price + " - " + "$"+product.prices[product.prices.length-1].price : '' }}</p>
							<p class="card-text text-white h3" v-else>${{ product.prices.length > 0 ? product.prices[0].price : '' }}</p>
							
						</div>
						<div class="card-footer border-0 bg-red-moi">
							<!-- <button
								v-b-modal.modal-delight
								v-if="validateDelight"
								@click="selectedProduct(product.id)" 
								class="btn btn-rounded" 
								style="font-weight: bold; background: #FFF; text-orientation: center; color: #F04150; border-radius: 12px; border-color: white;"
							>
								COMPRA YA EN 1 CLIC
							</button> -->
							<router-link :to="{ name: 'producto', params: {id: product.id} }" class="btn btn-rounded" style="font-weight: bold; background: #FFF; text-orientation: center; color: #F04150; border-radius: 12px; border-color: white;">VER PRODUCTO</router-link>

						</div>
					</div>
				</div>
			</div><!-- FIN MERCH -->
			
			<h2 class="text-left">Suscripciones</h2>
			<div class="row" v-if="products.length > 0">
				<div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="product in products.filter(property => property.product_type_id.id === 3 || property.product_type_id.id === 6)" v-bind:key="product.id">
					<div class="card product-card my-3 mb-3">

						<router-link :to="{ name: 'producto', params: {id: product.id} }" class="text-white">
							<img :src="product.big_picture" :alt="product.name" class="card-img-top">
						</router-link>
					
						<div class="card-body bg-red-moi">
							<h5 class="card-title" style="font-size: 0.96rem">
								<router-link :to="{ name: 'producto', params: {id: product.id} }" class="text-white">
									{{ product.name }}
								</router-link>
							</h5>
							<p class="card-text text-white" v-if="product.prices.length > 1">${{ product.prices.length > 0 ? product.prices[0].price + " - " + "$"+product.prices[product.prices.length-1].price : '' }}</p>
							<p class="card-text text-white h3" v-else>${{ product.prices.length > 0 ? product.prices[0].price : '' }}</p>
							
						</div>
						<div class="card-footer border-0 bg-red-moi">
							<!-- <button
								v-b-modal.modal-delight
								v-if="validateDelight"
								@click="selectedProduct(product.id)" 
								class="btn btn-rounded" 
								style="font-weight: bold; background: #FFF; text-orientation: center; color: #F04150; border-radius: 12px; border-color: white;"
							>
								COMPRA YA EN 1 CLIC
							</button> -->
							<router-link :to="{ name: 'producto', params: {id: product.id} }" class="btn btn-rounded" style="font-weight: bold; background: #FFF; text-orientation: center; color: #F04150; border-radius: 12px; border-color: white;">VER PRODUCTO</router-link>

						</div>
					</div>
				</div>
			</div><!-- .row -->
			<div class="row" v-else>
				<div class="col">
					<h3>{{ this.no_product }}</h3>
				</div>
			</div>
				<h2 class="text-left pt-4">Especiales</h2>
			<div class="row" v-if="products.length > 0">
				<div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="product in products.filter(property => property.product_type_id.id === 5 || property.product_type_id.id === 2 || property.product_type_id.id === 7)" v-bind:key="product.id">
					<div class="card product-card my-3 mb-3">
						<router-link :to="{ name: 'producto', params: {id: product.id} }" class="text-white">
							<img :src="product.big_picture" :alt="product.name" class="card-img-top">
						</router-link>
						
						<div class="card-body bg-red-moi">
							<h5 class="card-title" style="font-size: 0.96rem">

								<router-link :to="{ name: 'producto', params: {id: product.id} }" class="text-white">
									{{ product.name }}
								</router-link>

							</h5>
							<p class="card-text text-white" v-if="product.prices.length > 1">${{ product.prices.length > 0 ? product.prices[0].price + " - " + "$"+product.prices[product.prices.length-1].price : '' }}</p>
							<p class="card-text text-white h3" v-else>${{ product.prices.length > 0 ? product.prices[0].price : '' }}</p>
							
						</div>
						<div class="card-footer border-0 bg-red-moi">	
							<router-link :to="{ name: 'producto', params: {id: product.id} }" class="btn btn-rounded" style="font-weight: bold; background: #FFF; text-orientation: center; color: #F04150; border-radius: 12px; border-color: white;">VER PRODUCTO</router-link>
						</div>
					</div>
				</div>
			</div><!-- .row -->
			<div class="row" v-else>
				<div class="col">
					<h3>{{ this.no_product }}</h3>
				</div>
			</div>
			<h2 class="text-left pt-4">Paquetes</h2>
			<div class="row" v-if="products.length > 0">
				<div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="product in products.filter(property => property.product_type_id.id === 4)" v-bind:key="product.id">
					<div class="card product-card my-3 mb-3">
						<router-link :to="{ name: 'producto', params: {id: product.id} }"><img :src="product.big_picture" :alt="product.name" class="card-img-top"></router-link>
						<div class="card-body bg-red-moi">
							<h5 class="card-title" style="font-size: 0.96rem">
								<router-link class="text-white" :to="{ name: 'producto', params: {id: product.id} }">
									{{ product.name }}
								</router-link>
							</h5>
							<p class="card-text text-white" v-if="product.prices.length > 1">${{ product.prices.length > 0 ? product.prices[0].price + " - " + "$"+product.prices[product.prices.length-1].price : '' }}</p>
							<p class="card-text text-white h3" v-else>${{ product.prices.length > 0 ? product.prices[0].price : '' }}</p>
							
						</div>
						<div class="card-footer border-0 bg-red-moi">
							<router-link :to="{ name: 'producto', params: {id: product.id} }" class="btn btn-rounded" style="font-weight: bold; background: #FFF; text-orientation: center; color: #F04150; border-radius: 12px; border-color: white;">VER PRODUCTO</router-link>
						</div>
					</div>
				</div>
			</div><!-- .row -->
			<div class="row" v-else>
				<div class="col">
					<h3>{{ this.no_product }}</h3>
				</div>
			</div>
			<h2 class="text-left pt-4">Revistas</h2>
			<div class="row" v-if="products.length > 0">
				<div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="product in products.filter(property => property.product_type_id.id === 1)" v-bind:key="product.id">
					<div class="card product-card my-3 mb-3">
						<router-link :to="{ name: 'producto', params: {id: product.id} }"><img :src="product.big_picture" :alt="product.name" class="card-img-top"></router-link>
						<div class="card-body bg-red-moi">
							<h5 class="card-title" style="font-size: 0.96rem">
								<router-link class="text-white" :to="{ name: 'producto', params: {id: product.id} }">
									{{ product.name }}
								</router-link>
							</h5>
							<p class="card-text text-white" v-if="product.prices.length > 1">${{ product.prices.length > 0 ? product.prices[0].price + " - " + "$"+product.prices[product.prices.length-1].price : '' }}</p>
							<p class="card-text text-white h3" v-else>${{ product.prices.length > 0 ? product.prices[0].price : '' }}</p>
							
						</div>
						<div class="card-footer border-0 bg-red-moi">
							<router-link :to="{ name: 'producto', params: {id: product.id} }" class="btn btn-rounded" style="font-weight: bold; background: #FFF; text-orientation: center; color: #F04150; border-radius: 12px; border-color: white;">VER PRODUCTO</router-link>
						</div>
					</div>
				</div>
			</div><!-- .row -->
			<div class="row" v-else>
				<div class="col">
					<h3>{{ this.no_product }}</h3>
				</div>
			</div>
		</div>

		<b-modal
			ref="modal-delight"
			hide-footer
			id="modal-delight"
			title="¡Elige!"
			@hide="closeModal"
		>
            <div v-show="productCart.type_id == 3 || productCart.id == 108 || productCart.id == 85 || productCart.id == 86 ">
                <p class="my-4 text-center font-weight-bold">
                    ¿Estás seguro que no deseas agregar una alegría?
                </p>
                <DelightSelection
                    @click="addDelightToProduct"
                ></DelightSelection>
                <button
                    @click="hideModalDelight"
                    class="buy-now btn btn-default btn-lg border border-dark text-dark mx-auto"
                    style="width: 100%"
                >
                    No quiero
                </button>
            </div>
			<h4 v-if="is_guest || productCart.type_id == 6"
				style="font-weight: bold; 
				background: rgb(255, 255, 255); 
				color: rgb(240, 65, 80); 
				border-radius: 12px; 
				border-color: white;
				text-align:center; margin-top:30px;">Continuar como</h4>
			<div class="mt-4 d-flex justify-content-between">
				<button type="button" class="btn btn text-white btn-secondary d-inline "
				style="background: rgb(15, 24, 43); font-weight: bold; width: 175px; height: 40px;"
				@click="ingresarComoInvitado"
				v-if="is_guest || productCart.type_id == 6">
					<span>Invitado</span>
				</button>
				<button type="button" class="btn btn text-white btn-secondary d-inline"
				style="background: rgb(15, 24, 43); font-weight: bold; width: 175px; height: 40px;"
				@click="showModalLogin"
				v-if="is_guest || productCart.type_id == 6">
					<span>Iniciar sesión</span>
				</button>
			</div>
		</b-modal>
		<div> 
			<DelightSelection
				:validate="validateDelight"
				@modify="modifyVerificationDelight"
				@click="addDelightToProduct"
			></DelightSelection>
		</div>
		<LoginForm ref="login"></LoginForm>
	</div><!-- .product-section -->
</template>

<script>
import Loading from "vue-loading-overlay";
import DelightSelection from "./DelightSelection.vue";
const axios = require("axios");
import LoginForm from "./LoginForm.vue";


export default {
	name: 'ProductList',
	components:{
		Loading,
		DelightSelection,
		LoginForm,
	},
	props: ['no_product', 'products'],
	data(){
		return{
			product: null,
			productCart: {
                id: null,
                item_name: null,
                item_description: null,
                quantity: 1,
                attribute: null,
                price: 0,
                priceObj: null,
                delight: null,
                type_id: null,
                is_recurrency: false,
            },
            productImage: "",
            productPrice: 0,
            prices: null,
            is_subscription: false,
            attributes: [],
            attributeSelected: "",
            haveAttributesFilter: true,
            is_loading: false,
            similarProducts: [],
            typeProductId: null,
            allProdducts: null,
            validateDelight: false,
            validateModalDelight: false,
            productGallery: [],
			is_login: false,
			is_guest: false,
			disablebutton: null,
			api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
			guestUser: false,
			stateSubscription:true,
			guestAccess: false
		}
	},
	mounted(){
	},
	methods: {
	closeModal: function(){
			this.is_guest = false;
			if ($cookies.get("utoken")) {
				this.$store.commit('finishStoreSubscription');
			}else{
				if(this.guestAccess){
					console.log('acceso de invitado');
					this.validateModalDelight = true;
					this.addToCartSubscription();
				}
				else{
					this.$store.commit('finishStoreSubscription');
				}
			}
        },
		baseUrlImage: function(file){
			return this.base_url + '/storage/upload/' + file;
		},
		selectedProduct: function(id){
            if ($cookies.get("ctoken")) {
                axios({
                    method: "GET",
                    url: this.api_url + "/products/" + id,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + $cookies.get("ctoken"),
                    },
                })
                .then((response) => {
                      this.product = response.data.data
                      console.log('producto seleccionado: ',  this.product);
                      this.loadPrices(this.product);

                    if ($cookies.get("ctoken")) {
                        let product = this.product;
                        this.productCart.id = product.id;
                        this.productCart.item_name = product.name;
                        this.productCart.item_description =product.description;
                        this.productCart.type_id = product.product_type_id.id;
                        this.productImage = product.big_picture;
                        this.attributes = product.attribute;
                        this.typeProductId = product.product_type_id.id;
                        this.productGallery = product.gallery;
                    } else{
                        console.info('no se encontro la cookie');
                        return false;
                    }
                    if($cookies.get('utoken')){
                        console.info("Usuario logeado")
                        this.is_login = true;
                        if (this.productCart.type_id == 6){
                            console.info("Es una suscripcion digital");
                            this.$refs['modal-delight'].hide();
                            this.is_loading = false;
                            this.is_guest = false;
                            this.validateModalDelight = true;
                            this.addToCartSubscription();
                        }
                        return false;
                    }else{
                        this.is_login = false
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
            } else {
                console.info("No se encontro la cookie");
            }
		},
		addToCartSubscription: function(){
			console.log(this.productCart);
			this.is_loading = true;
			if(this.validateDelight && this.productCart.delight == null && !this.validateModalDelight){
				return null;
			}else{				
				if(this.productCart.id && 
					this.productCart.item_name && 
					this.productCart.price > 0 && 
					this.productCart.quantity > 0){

					if(this.productCart.price > 40 && this.productPrice != 0){
						if (this.productCart.type_id == 3 || this.productCart.type_id == 6){
                            this.productCart.is_recurrency = true;
                        }
						if(this.guestUser){
							this.$router.push({name: "guestCheckoutSubscriptions", params: this.productCart});
							console.log('accediste como invitado');
							this.$store.commit('addProductCartSubscription', this.productCart);
							console.info('se agrego la suscripcion');
							this.is_loading = false;


							window.dataLayer.push({
								'event': 'suscripcionAgregada',
								'pageURL': this.$router.currentRoute.fullPath,
								'subscription': this.productCart,
								'visitorType': "usuario invitado",
								'dateVisit': new Date().toLocaleString('en-US')
							});

						}
						if ($cookies.get("utoken")) {
							this.$router.push({name: "checkoutSubscription", params: this.productCart});
							console.log('usuario logeado');
							console.info('se agrego la suscripcion');
							console.log(this.productCart);
							this.$store.commit('addProductCartSubscription', this.productCart);
							this.is_loading = false;

							window.dataLayer.push({
								'event': 'suscripcionAgregada',
								'pageURL': this.$router.currentRoute.fullPath,
								'subscription': this.productCart,
								'visitorType': "usuario registrado",
								'dateVisit': new Date().toLocaleString('en-US')
							});
						}
						else{
							this.is_loading = false;
							this.is_guest = true;
							console.log('usuario no logeado');
							return false;
						}
					}
					else {
                        this.$snotify.warning("Se debe de elegir el precio del producto");
                    }
				}
				else{
					this.$snotify.warning("Faltan datos del producto");
				}
			}
		},
		loadPrices: function (product) {
            this.prices = product.prices;
            // Preseleccionamos el primer precio cuando se cargan los precios al combo
            if (this.prices.length > 0){
                this.productCart.price = this.prices[0].price;
                this.productCart.priceObj = this.prices[0];
                this.productPrice = this.prices[0];
            }
        },
        addDelightToProduct: function (delight) {
			if ($cookies.get("utoken")) {
				console.info("Se agrego la alegria en la suscripcion", this.productCart);
				this.productCart.delight = delight;
				this.productCart.price = this.productCart.price + this.productCart.delight.prices[0].price;
				this.hideModalDelight();
			}else{
				console.log('es invitado');
				this.productCart.delight = delight;
				this.productCart.price = this.productCart.price + this.productCart.delight.prices[0].price;
				this.is_guest = true;
			}
        },
        modifyVerificationDelight: function (param) {
            this.validateDelight = param;
        },
        hideModalDelight() {

			if ($cookies.get("utoken")) {
				console.log('continua el proceso de agregar');
				this.validateModalDelight = true;
				this.addToCartSubscription();
			}else{
				console.log('es invitado');
				this.is_guest = true;
			}
        },
		ingresarComoInvitado: function(){
			this.guestAccess = true;
			console.log('ingresaste como invitado');
			this.guestUser = true;
			this.$refs['modal-delight'].hide();
			// se ejecuta la funcion addToCartSubscription automaticamente al cerrar el modal 
		},
		showModalLogin: function(){
			this.guestAccess = true;
			console.log('inicia sesion');
			this.$refs['modal-delight'].hide();
			this.$refs.login.showModal(this.productCart);
		}
	}
}
</script>

<style scoped>
.product-card{
	min-height: 490px;
}
.bg-red-moi {
	background-color: #F04150;
}
.btn.btn-primary{
	letter-spacing: normal;
}
@media (max-width: 575px) {
	.product-card {
		width: 80%;
		margin: auto;
	}
}
@media (max-width: 430px) {
	.product-card {
		width: 90%;
		margin: auto;
	}
}
</style>
